export default "__VITE_ASSET__DVEmmkTZ__"